import { createRouter, createWebHistory } from 'vue-router'
import { cancelAllRequests } from '@/utils/request'
import { useUserInfoStore } from '@/stores/index'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index.vue'),
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/login.vue'),
      meta: {
        title: '登录',
      },
    },
    {
      path: '/guide',
      name: 'guide',
      component: () => import('@/views/guide.vue'),
      meta: {
        title: '入驻指南',
      },
    },
    {
      path: '/rules',
      name: 'rules',
      component: () => import('@/views/rules.vue'),
      meta: {
        title: '推广规则',
      },
    },
    {
      path: '/certification',
      name: 'certification',
      component: () => import('@/views/certification/index.vue'),
      meta: {
        title: '推广认证',
      },
    },
    {
      path: '/poster',
      name: 'poster',
      component: () => import('@/views/poster.vue'),
      meta: {
        title: '分享购买',
      },
    },
    {
      path: '/settleAccounts-record',
      name: 'settleAccounts-record',
      component: () => import('@/views/settleAccounts/record.vue'),
      meta: {
        title: '结算记录',
      },
    },
    {
      path: '/settleAccounts-details',
      name: 'settleAccounts-details',
      component: () => import('@/views/settleAccounts/details.vue'),
      meta: {
        title: '结算详情',
      },
    },
    {
      path: '/promotion-record',
      name: 'promotion-record',
      component: () => import('@/views/promotion/record.vue'),
      meta: {
        title: '推广记录',
      },
    },
    {
      path: '/myProfile',
      name: 'myProfile',
      component: () => import('@/views/myProfile/index.vue'),
      meta: {
        title: '个人信息',
      },
    },
    {
      path: '/myProfile-info',
      name: 'myProfile-info',
      component: () => import('@/views/myProfile/info/info.vue'),
      meta: {
        title: '个人资料',
      },
    },
    {
      path: '/info-head',
      name: 'info-head',
      component: () => import('@/views/myProfile/info/head.vue'),
      meta: {
        title: '个人头像',
      },
    },
    {
      path: '/edit-mobile',
      name: 'edit-mobile',
      component: () => import('@/views/myProfile/info/editMobile/index.vue'),
      meta: {
        title: '修改手机号',
      },
    },
    {
      path: '/info-bankInfo',
      name: 'info-bankInfo',
      component: () => import('@/views/myProfile/info/bankInfo.vue'),
      meta: {
        title: '银行信息',
      },
    },
    {
      path: '/info-certification',
      name: 'info-certification',
      component: () => import('@/views/myProfile/certification.vue'),
      meta: {
        title: '资格认证',
      },
    },
    {
      path: '/contract',
      name: 'contract',
      component: () => import('@/views/myProfile/contract.vue'),
      meta: {
        title: '合同管理',
      },
    },
    {
      path: '/accountSecurity',
      name: 'accountSecurity',
      component: () => import('@/views/myProfile/accountSecurity.vue'),
      meta: {
        title: '账号安全',
      },
    },
  ],
})

// 全局导航守卫动态修改标题
router.beforeEach(async (to, from, next) => {
  cancelAllRequests()
  const useUserInfo = useUserInfoStore()
  console.log('🚀 ~ useUserInfo.getInitialized:', useUserInfo.getInitialized())
  if (!useUserInfo.getInitialized()) {
    await useUserInfo.initialize()
  }
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '推广'
  }
  next()
})

export default router
